import { COUNTRIES_DATA } from '@/lib/constants/countries'
import type {
  AdvertiserRepresentativeFormData,
  AdvertiserRepresentativeServerType,
} from '@/lib/types'

export const fromFormToStoreCreation = (
  data: AdvertiserRepresentativeFormData,
): AdvertiserRepresentativeServerType => {
  const countryObj = COUNTRIES_DATA.find((item) => item.iso === data.locale) as {
    iso: string
    name: string
    currency: string
    language: string
  }

  return {
    name: data.storeName,
    categories: data.categories,
    domains: data.domains.filter((item) => !!item.value).map((item) => item.value.toLowerCase()),
    country: data.locale,
    currency: countryObj.currency,
    language: countryObj.language,
    billing: {
      company_name: data.companyName,
      street: data.address,
      postal_code: data.postalCode,
      city: data.city,
      vat_number: data.vatNumber,
    },
    logo_url: data.logo,
  }
}
